export default "__VITE_ASSET__pHZfOfFz__"